export const BEHAVIOR_GET_MULTIPLE =  "BEHAVIOR_GET_MULTIPLE"
export const BEHAVIOR_GET_DROPDOWNS =  "BEHAVIOR_GET_DROPDOWNS"
export const BEHAVIOR_GET_ONE =  "BEHAVIOR_GET_ONE"
export const BEHAVIOR_REGISTER_SUCCESS =  "BEHAVIOR_REGISTER_SUCCESS"
export const BEHAVIOR_REGISTER_FAIL =  "BEHAVIOR_REGISTER_FAIL"
export const BEHAVIOR_LOADING =  "BEHAVIOR_LOADING"
export const BEHAVIOR_LOADING_ERROR =  "BEHAVIOR_LOADING_ERROR"
export const BEHAVIOR_ACTIVATE_FAIL =  "BEHAVIOR_ACTIVATE_FAIL"
export const BEHAVIOR_ACTIVATE_SUCCESS =  "BEHAVIOR_ACTIVATE_SUCCESS"
export const BEHAVIOR_UPDATE_SUCCESS =  "BEHAVIOR_UPDATE_SUCCESS"
export const BEHAVIOR_UPDATE_FAIL =  "BEHAVIOR_UPDATE_FAIL"
export const BEHAVIOR_DELETE_SUCCESS =  "BEHAVIOR_DELETE_SUCCESS"
export const BEHAVIOR_DELETE_FAIL =  "BEHAVIOR_DELETE_FAIL"
export const BEHAVIOR_EDIT =  "BEHAVIOR_EDIT"